import React, { useEffect } from 'react';
import './assets/css/colors.css'
import './assets/css/styles.css'
import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/scroll-to-top';
import IndexFive from './pages/index/index-five';
import ListLayoutOne from './pages/property/list-layout-one';
import GridLayoutWithSidebar from './pages/property/grid-layout-with-sidebar';
import ListLayoutWithMap from './components/navbar/list-layout-with-map';
import SinglePropertyOne from './pages/property/single-property-1';
import Agents from './pages/agents/agents';
import Pricing from './pages/pricing';
import Contact from './pages/contact';
import CreateAccount from './pages/admin/create-account';
import { removeConsoleLogs } from './utils/removeConsole';
import Terms from './pages/general/terms';
import PrivacyPolicy from './pages/general/privacyPolicy';
import AddSpace from './pages/addSpace/addSpace';
import MySpace from './pages/myspace/myspace';
import { payment } from './services/ApiServices';
import HowItWork from './pages/howItWork';
import FreeAd from './pages/freeAd';
import Faq from './pages/faq';
import Faqs from './components/faq';

function App() {
  removeConsoleLogs();
  const userProfileString = localStorage?.getItem('userProfile');
  const userDetail: any = userProfileString ? JSON.parse(userProfileString) : null;

  const fetchPaymentSheetParams = async () => {

    payment(userDetail?.api_token).then((res) => {
      console.log("payment success", res);
      const { paymentIntent, ephemeralKey, customer } = res;
      localStorage.setItem('orderAmount', res?.order_amount);
      localStorage.setItem('paymentIntent', paymentIntent);
      // setIntent(res.paymentIntent);
      // setEphermal(res.ephemeralKey);
      // setCustormer(res.customer);
      // setIntentId(res.payment_intent_id);
      // setOrderAmount(res.order_amount)
      return paymentIntent
    }).catch((err) => {
      console.log("payment error", err);
    })
  }

  useEffect(() => {
    if (userDetail) {
      fetchPaymentSheetParams();
    }
  }, [])
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={18}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{}}
      /> <Routes>
        <Route path='/' element={<IndexFive />} />
        <Route path='/list-layout-one' element={<ListLayoutOne />} />
        <Route path='/grid-layout-with-sidebar' element={<GridLayoutWithSidebar />} />
        <Route path='/list-layout-with-map' element={<ListLayoutWithMap />} />
        <Route path='/property-details/:spaceId' element={<SinglePropertyOne />} />
        <Route path='/agents' element={<Agents />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/create-account' element={<CreateAccount />} />
        <Route path='/termes' element={<Terms />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/add-space' element={<AddSpace />} />
        <Route path='/my-space' element={<MySpace />} />
        <Route path='/how-it-works' element={<HowItWork />} />
        <Route path='/free-ad' element={<FreeAd />} />
        <Route path='/faq' element={<Faq />} />
        {/* <Route path='/faq' element={<Faqs faqData={[{ id: 1, title: "What is CommercialSPC?", desc: "CommercialSPC is a global real estate market place that connects property providers with property users. Our platform allows property provider to advertise commercial properties for sale, vacant commercial space for lease, residential properties for sale or for rent, and multifamily properties for sale." }, { id: 2, title: "How do I use the CommercialSPC website to find properties?", desc: "To search for properties: Visit commercialspc.com. Use the search functionality to filter listings based on your requirements (e.g., location, property type). Browse through the listings and contact the property owner or agent directly for more information." }, { id: 3, title: "How can I advertise my commercial property on CommercialSPC?", desc: "To advertise a property: Navigate to the home page on Commercialspc.com. Create an account or log in. Provide detailed information about your property, including photos and contact details. Submit your listing for it to go live on the platform. You will pay a low $10.00 fee for the advertisement and the advertisement lasts for 45 days." }]} />} /> */}
      </Routes>
      <ScrollToTop />
    </>
  );
}

export default App;
